import resellerPaymentsHandler from "../../services/ResellerPayments";

export default {
    async loadResellerPayments({commit, dispatch}, payload) {
        const {data} = await resellerPaymentsHandler.all(payload);

        commit('SET_RESELLER_PAYMENTS', data);
    },
    async storeResellerPayment({commit, dispatch}, payload) {
        return resellerPaymentsHandler.store(payload);
    },
    async updateResellerPayment({commit, dispatch}, payload) {
        return resellerPaymentsHandler.update(payload);
    },
    async destroyResellerPayment({commit, dispatch}, payload) {
        return resellerPaymentsHandler.destroy(payload);
    },
}
